import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import TopBar from './TopBar';
import TemplateUploadProgressModal from '../UI/TemplateUploadProgressModal';

const Layout = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <TopBar />
        <Toolbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            backgroundColor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <Outlet />
        </Box>
      </Box>
      {/* Global modal that shows live progress + status comparison for every
          "Upload Template" flow while the import request is running. */}
      <TemplateUploadProgressModal />
    </Box>
  );
};

export default Layout;
